import { useState, ReactNode, useRef, useEffect } from "react";
import { CSSTransition } from "react-transition-group";

import { useBackable } from "../NativeContext";

import style from "../style/components/SideScreen.module.css";
import "../style/CSSTransition.css";

const SideScreen = ({
    children,
    header = true,
    appear,
    title,
    id,
    close,
    inform,
}: {
    children: ReactNode;
    header?: boolean;
    appear: boolean;
    title?: string;
    id: string;
    close?: () => void;
    inform?: () => void;
}) => {
    useBackable(
        id,
        () => {
            close?.();
        },
        appear
    );

    const container = useRef(null);
    return (
        <>
            <CSSTransition
                in={appear}
                timeout={400}
                classNames="side-screen--slide"
                unmountOnExit
                nodeRef={container}
            >
                <div ref={container} className={[style["container"]].join(" ")}>
                    {header && (
                        <div className={style["header"]}>
                            <Button onClick={close}>
                                <svg
                                    width="13"
                                    height="21"
                                    viewBox="0 0 13 21"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="#333333"
                                >
                                    <path d="M0.78125 10.5391C0.78125 10.2461 0.886719 9.97656 1.10938 9.76562L10.4023 0.671875C10.6016 0.472656 10.8594 0.367188 11.1641 0.367188C11.7734 0.367188 12.2422 0.824219 12.2422 1.43359C12.2422 1.72656 12.1133 1.99609 11.9258 2.19531L3.39453 10.5391L11.9258 18.8828C12.1133 19.082 12.2422 19.3398 12.2422 19.6445C12.2422 20.2539 11.7734 20.7109 11.1641 20.7109C10.8594 20.7109 10.6016 20.6055 10.4023 20.3945L1.10938 11.3125C0.886719 11.0898 0.78125 10.832 0.78125 10.5391Z" />
                                </svg>
                            </Button>

                            <h4 className={style["text--title"]}>{title}</h4>

                            <Button onClick={inform} disable={!Boolean(inform)}>
                                <svg
                                    width="24"
                                    height="25"
                                    viewBox="0 0 24 25"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="#333333"
                                >
                                    <path d="M12 24.4922C5.47266 24.4922 0.046875 19.0664 0.046875 12.5391C0.046875 6 5.46094 0.585938 11.9883 0.585938C18.5273 0.585938 23.9531 6 23.9531 12.5391C23.9531 19.0664 18.5391 24.4922 12 24.4922ZM12 22.5C17.5312 22.5 21.9727 18.0703 21.9609 12.5391C21.9492 7.00781 17.5195 2.57812 11.9883 2.57812C6.45703 2.57812 2.05078 7.00781 2.05078 12.5391C2.05078 18.0703 6.46875 22.5 12 22.5ZM11.9883 14.6484C11.4023 14.6484 11.0742 14.3203 11.0625 13.7227L10.9102 7.52344C10.8984 6.92578 11.3438 6.49219 11.9766 6.49219C12.5977 6.49219 13.0664 6.9375 13.0547 7.53516L12.8789 13.7227C12.8672 14.332 12.5391 14.6484 11.9883 14.6484ZM11.9883 18.457C11.3086 18.457 10.7227 17.9062 10.7227 17.2383C10.7227 16.5703 11.2969 16.0195 11.9883 16.0195C12.668 16.0195 13.2422 16.5586 13.2422 17.2383C13.2422 17.918 12.6562 18.457 11.9883 18.457Z" />
                                </svg>
                            </Button>
                        </div>
                    )}

                    {children}
                </div>
            </CSSTransition>
        </>
    );
};

const Button = ({
    children,
    disable,
    onClick,
}: {
    children: ReactNode;
    disable?: boolean;
    onClick?: () => void;
}) => {
    const [clicked, setClicked] = useState<boolean>(false);

    return (
        <button
            className={[
                style["button"],
                clicked && style["button--clicked"],
                disable && style["button--disable"],
            ].join(" ")}
            onClick={onClick}
            onMouseDown={() => setClicked(true)}
            onMouseUp={() => setClicked(false)}
            onTouchStart={() => setClicked(true)}
            onTouchEnd={() => setClicked(false)}
        >
            {children}
        </button>
    );
};

export default SideScreen;
